import { createMiddleware } from '@shared/redux';
import { HANDLE_GET_CLUSTERS, listClusters } from '@domain/omnichannel-budget-manager/clusters/clusters.state';
import { getEntityId } from '@shared/utils';
import { getObjectSelectedData, getTypeOfSelectedObject } from '@domain/object-selected';
import { getLoggedUser } from '@domain/logged-user';

const isClientSelected = entity => entity === 'clients';

export const clustersMiddleware = createMiddleware({
    [HANDLE_GET_CLUSTERS]: (state) => {
        const { customerId, customerType, loggedUser } = getHandleGetClustersParams(state);

        if (isClientSelected(customerType)) {
            return listClusters({
                clientId: customerId,
                organizationId: loggedUser.company.id,
            });
        }

        return [];
    },
});

export const getHandleGetClustersParams = (state) => {
    const objectSelected = getObjectSelectedData(state);
    const customerId = getEntityId(objectSelected);
    const customerType = getTypeOfSelectedObject(objectSelected);
    const loggedUser = getLoggedUser(state);

    return {
        customerId,
        customerType,
        loggedUser,
    };
};
